import { render } from "./indice.vue?vue&type=template&id=78fc7392"
import script from "./indice.vue?vue&type=script&lang=js"
export * from "./indice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__